module.exports = __webpack_public_path__ + "static/media/organigrama.e682bde2.png";